//deps
import styled from "styled-components";

// internal deps
import { Tooltip, AriaHidden } from "@swiggy-private/core-ui";

// dls components
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

import { IColorMode } from "@swiggy-private/dls-web-common/dist/components/types";

interface IProps {
    bottomArrowPosition: "left" | "right";
    forceColorMode?: IColorMode;
    size?: "default" | "large";
}

export const TooltipContainer = styled(AriaHidden)<IProps>(({ theme, bottomArrowPosition }) => ({
    position: "absolute",
    top: 0,
    transform: "translateY(-100%)",
    zIndex: 1,
    ...(bottomArrowPosition === "right" && {
        right: theme.spacing.medium,
    }),
    ...(bottomArrowPosition === "left" && {
        left: theme.spacing.medium,
    }),
}));

export const TooltipIcon = styled.div<{ size?: "default" | "large" }>(({ theme, size }) => ({
    marginRight: theme.spacing.xSmall,
    height: size === "large" ? theme.spacing.large : theme.spacing.xxLarge,
    width: size === "large" ? theme.spacing.large : theme.spacing.xxLarge,
}));

export const StyledTooltip = styled(Tooltip)<IProps>`
    max-width: ${(props) => (props.size === "large" ? "320px" : "260px")};
    width: ${(props) => (props.size === "large" ? "auto" : undefined)};
    min-width: ${(props) => (props.size === "large" ? "260px" : undefined)};
    z-index: 1;
    height: fit-content;
    flex-direction: column;

    > button {
        position: absolute;
        top: ${(props) => props.theme.spacing.small};
        right: ${(props) => props.theme.spacing.xSmall};
        align-self: auto;
    }

    &:before {
        left: ${(props) => {
            return props.bottomArrowPosition === "right" ? "inherit" : props.theme.spacing.xLarge;
        }};
        right: ${(props) => {
            return props.bottomArrowPosition === "right" ? props.theme.spacing.xLarge : "inherit";
        }};
    }
`;

export const TooltipContent = styled.div(() => ({
    display: "flex",
}));

export const TooltipText = styled(Text)(({ theme }) => ({
    marginTop: `calc(${theme.spacing.xxxSmall} * -1)`,
    flex: 1,
    wordBreak: "break-word",
}));

export const NewTagWrapper = styled.div(({ theme }) => ({
    height: "fit-content",
    width: "fit-content",
    margin: `0 ${theme.spacing.xSmall} ${theme.spacing.xSmall} 0`,
}));
